const translations = {
    lastActivity: 'Last Activity',
    lastEdited: 'Last Edited',
    loading: 'Loading...',
    name: 'Name',
    noMoreBoundaries: 'No more boundaries'
};

export default translations;
